/** @namespace TRC.dom.CustomModulesManager.registeredModules.customHooks */

const STICKY_FIRST_ITEM_HOOK_NAME = 'sticky-first-item';

class StickyFirstItem {
    constructor(data, box, trcManager, options) {
        this.trcManager = trcManager;
        this.box = box;
        this.data = data;
        this.isSponsoredContent = TRC.util.isTrue(this.data.isSyndicated);
        this.config = StickyFirstItem.getStickyFirstItemConfig(options);
        this.seenFirstCard = false;
        this.isMobile = TRC.Device.isTouchDevice;
        this.cssClasses = this.isMobile ? StickyFirstItem.CSS_CLASSES.MOBILE : StickyFirstItem.CSS_CLASSES.DESKTOP;
        // eslint-disable-next-line prefer-destructuring
        this.feedContainer = document.getElementsByClassName('tbl-feed-container')[0];
        this.brandingElement = this.getBranding();
        this.createStickyOverlay();
        // eslint-disable-next-line prefer-destructuring
        this.disclosureElement = document.getElementsByClassName(this.cssClasses.DISCLOSURE)[0];
        this.injectConfigStyle();
        this.defineEventsObject();
        this.addObservers();
        this.addClickEvents();
        this.closeBtn = this.createCloseButtonElement();
        this.innerItem.appendChild(this.closeBtn);

        if (!this.isMobile) {
            this.innerItem.appendChild(StickyFirstItem.createArrowButtonElement());
        }
        if (TRC.Browser.ie) {
            document.getElementsByClassName('tbl-sticky-item-arrowBtn')[0].style.top = '5px';
        }

    }

    injectConfigStyle() {
        TRC.dom.injectStyle(`#${StickyFirstItem.CSS_CLASSES.OUTER_CONTAINER} .${this.cssClasses.STICKY_ITEM_CONTAINER} {
            width: ${this.feedElement.clientWidth - 2}px;
            z-index: ${this.config.stickyItemZIndex};
            bottom: ${this.config.distanceFromBottomViewport}px;
            transform: translateY(${90 + Number(this.config.distanceFromBottomViewport)}px);
        }`);
    }

    getBranding() {
        const innerBranding = this.box.getElementsByClassName('branding')[0].innerText;
        const innerBrandingElement = `<span class=${this.cssClasses.BRANDING}>${innerBranding}</span>`;

        let disclosureElement = '';
        if (this.data.isSyndicated && JSON.parse(this.data.isSyndicated)) {
            const [firstCardDisclosureElement] = this.box.getElementsByClassName('attribution-disclosure-link-sponsored');
            const firstCardDisclosureElementPopupHref = firstCardDisclosureElement.firstChild.href;
            const disclosure = firstCardDisclosureElement.innerText;
            disclosureElement = `<span class=${this.cssClasses.BRANDING}> | </span>
                                    <span class=${this.cssClasses.DISCLOSURE}>
                                        <a href="${firstCardDisclosureElementPopupHref}">${disclosure}</a>
                                    </span>`;
        }
        return innerBrandingElement + disclosureElement;
    }

    static getStickyFirstItemConfig(options = {}) {
        return {
            stickyItemZIndex: options.stickyItemZIndex || 9999,
            distanceFromBottomViewport: options.distanceFromBottomViewport || 0,
            enableItemClickAfterNumOfMilliseconds: options.enableItemClickAfterNumOfMilliseconds || 500,
            firstItemActivationThreshold: options.firstItemActivationThreshold || 0.5,
            stickyItemDisappearThreshold: options.stickyItemDisappearThreshold || 0,
            stickyItemHideAfter: options.stickyItemHideAfter || 0
        };
    }

    handleCloseBtnClick(event) {
        this.itemContainer.style.display = 'none';
        this.innerItem.style.display = 'none';
        this.trcManager.sendAbTestEvent(STICKY_FIRST_ITEM_HOOK_NAME, this.eventObjects.closed);
        event.stopPropagation();
    }

    createCloseButtonElement() {
        return StickyFirstItem.createNewElement(
            'div', StickyFirstItem.CSS_CLASSES.CLOSE_BTN_WRAPPER, StickyFirstItem.CSS_CLASSES.CLOSE_BTN_WRAPPER,
            StickyFirstItem.getCloseButtonMarkup(),
            [{click: this.handleCloseBtnClick.bind(this)}]
        );
    }

    static createArrowButtonElement() {
        return StickyFirstItem.createNewElement(
            'div', null, StickyFirstItem.CSS_CLASSES.ARROW_BTN_WRAPPER,
            StickyFirstItem.getArrowButtonMarkup()
        );
    }

    static getArrowButtonMarkup() {
        return `
            <div class="tbl-sticky-item-arrowBtnCircle"></div>
            <svg class="${StickyFirstItem.CSS_CLASSES.ARROW_BTN}" viewBox="0 0 52 32">
                <path d="M39.308 1.455h11.601l-24.852 29.091-24.602-29.091h12.25l12.352 14.545z"></path>
            </svg>`;
    }

    static getCloseButtonMarkup() {
        return `<div class="${StickyFirstItem.CSS_CLASSES.CLOSE_BTN}">
               <svg width="10px" height="10px" viewBox="0 0 10 10">
                 <defs></defs>
                 <g id="Page-1" stroke="none" stroke-width="1" fill-rule="evenodd">
                   <g id="icons" transform="translate(-23.000000, -130.000000)">
                      <polygon id="Desktop-Close-initial" points="33 131.208868 31.7911325 130 28 133.791132 24.2088675 130 23 131.208868 26.7911325 135 23 138.791132 24.2088675 140 28 136.208868 31.7911325 140 33 138.791132 29.2088675 135"></polygon>
                   </g>
                 </g>
               </svg>
             </div>`;
    }

    static createNewElement(
        tag,
        id,
        classNames,
        innerHTML,
        eventsArray,
        attributesArray
    ) {
        if (!tag) {
            return false;
        }

        const domElement = document.createElement(tag);
        domElement.id = id || '';
        domElement.className = classNames || '';
        domElement.innerHTML = innerHTML || '';
        if (attributesArray) {
            attributesArray.forEach(attrObj => {
                const attrName = Object.keys(attrObj)[0];
                const attrValue = attrObj[attrName];
                domElement.setAttribute(attrName, attrValue);
            });
        }

        if (eventsArray) {
            eventsArray.forEach(eventObj => {
                const eventName = Object.keys(eventObj)[0];
                const callback = eventObj[eventName];
                TRC.dom.on(domElement, eventName, callback);
            });
        }

        return domElement;
    }

    feedExit() {
        if (!this.seenFirstCard) return;
        TRC.dom.addClass(this.innerItem, this.cssClasses.STICKY_ITEM_ACTIVE);
        if (!this.sentVisibleEvent) {
            this.sentVisibleEvent = true;
            // In case that video slider enabled, before sticky item was shown - do not fire AB event
            if (!StickyFirstItem.isVideoSliderOnFlag) {
                this.trcManager.sendAbTestEvent(STICKY_FIRST_ITEM_HOOK_NAME, this.eventObjects.visible);
            }
        }
        setTimeout(() => {
            this.clickingOnStickyFirstItemEnabled = true;
        }, 500 + this.config.enableItemClickAfterNumOfMilliseconds);
    }

    feedEnter() {
        this.clickingOnStickyFirstItemEnabled = false;
        TRC.dom.removeClass(this.innerItem, this.cssClasses.STICKY_ITEM_ACTIVE);
        if (this.sentVisibleEvent && !this.sentHiddenEvent) {
            this.sentHiddenEvent = true;
            this.trcManager.sendAbTestEvent(STICKY_FIRST_ITEM_HOOK_NAME, this.eventObjects.hidden);
        }
    }

    addObservers() {
        const firstCardObserver = {
            targetElement: this.box,
            onEnter: () => {
                this.seenFirstCard = true;
            },
            threshold: this.config.firstItemActivationThreshold
        };

        const feedObserver = {
            targetElement: this.feedContainer,
            onEnter: () => {
                this.feedEnter();
            },
            onExit: () => {
                this.feedExit();
            },
            threshold: this.config.stickyItemDisappearThreshold
        };

        TRC.intersections.observe(firstCardObserver);
        TRC.intersections.observe(feedObserver);

        TRC.dom.on(window, 'resize', this.onResizeHandler.bind(this));
    }

    allowUserClickIfClickingEnabled(e) {
        const stickyFirstItemContainerClassName = `${this.cssClasses.STICKY_ITEM_CONTAINER} ${this.cssClasses.STICKY_ITEM_ACTIVE} `;
        if ((((e.layerX < 10 || this.innerItem.offsetWidth - e.layerX < 10) || (e.layerY < 10 || this.innerItem.offsetHeight - e.layerY < 10))
            && e.target.className === stickyFirstItemContainerClassName) || !this.clickingOnStickyFirstItemEnabled) {
            return;
        }
        this.trcManager.sendAbTestEvent(STICKY_FIRST_ITEM_HOOK_NAME, this.eventObjects.click);
        this.isSponsoredContent ? window.open(this.data.logger_url, '_blank') : window.open(this.data.logger_url, '_self');
    }

    addClickEvents() {
        TRC.dom.on(this.innerItem, 'click', e => {
            this.allowUserClickIfClickingEnabled(e);
        });
        if (this.disclosureElement) {
            this.disclosureElement.style.zIndex = this.config.stickyItemZIndex + 1;
            TRC.dom.on(this.disclosureElement, 'click', event => TRC.aboutUs.open(event) || false);
        }
    }

    defineEventsObject() {
        this.eventObjects = {
            visible: {
                eventType: StickyFirstItem.EVENTS.VISIBLE,
                itemId: this.data['item-id']
            },
            hidden: {
                eventType: StickyFirstItem.EVENTS.HIDDEN,
                itemId: this.data['item-id']
            },
            click: {
                eventType: StickyFirstItem.EVENTS.CLICK,
                itemId: this.data['item-id']
            },
            closed: {
                eventType: StickyFirstItem.EVENTS.CLOSED,
                itemId: this.data['item-id']
            }
        };
    }

    onResizeHandler() {
        const [stickyItem] = document.getElementsByClassName(this.cssClasses.STICKY_ITEM_CONTAINER);
        stickyItem.style.width = `${this.feedElement.clientWidth - 2}px`;
    }

    createStickyOverlay() {
        const newDiv = document.createElement('div');
        newDiv.id = StickyFirstItem.CSS_CLASSES.OUTER_CONTAINER;
        newDiv.innerHTML = this.generateMarkup();
        this.itemContainer = newDiv;

        // eslint-disable-next-line prefer-destructuring
        this.feedElement = document.getElementsByClassName('trc_rbox_container')[0];
        this.feedElement.parentNode.insertBefore(newDiv, this.feedElement);
        // eslint-disable-next-line prefer-destructuring
        this.innerItem = document.getElementsByClassName(this.cssClasses.STICKY_ITEM_CONTAINER)[0];

        StickyFirstItem.listenToVideoSliderEvent(this.itemContainer);
    }

    generateMarkup() {
        const titleID = this.data.description === '' && !this.isMobile ? this.cssClasses.TITLE_EMPTY_DESCRIPTION : this.cssClasses.TITLE;
        return `
        <div class="${this.cssClasses.STICKY_ITEM_CONTAINER}">
            <div class="${this.cssClasses.THUMBNAIL_BASE}">
                <img class="${this.cssClasses.THUMBNAIL_BASE} ${this.cssClasses.THUMBNAIL}" src="${this.data.thumbnail}" alt="Thumbnail"/>
            </div>
            <div id="${this.cssClasses.TEXT}">
                <div id="${titleID}" class=${this.cssClasses.TRUNCATED_TEXT}>${this.data.title}</div>
                <div id="${this.cssClasses.DESCRIPTION}" class="${this.cssClasses.TRUNCATED_TEXT}">${this.data.description}</div>
                <div id=${this.cssClasses.BRANDING_WRAPPER}> 
                    ${this.brandingElement}
                </div> 
            </div>
        </div>
        `;
    }

    /**
     * Look for video slider. If slider is on - hide the sticky container
     * @param stickyContainer
     */
    static listenToVideoSliderEvent(stickyContainer) {
        StickyFirstItem.listenToVideoSlider = TRC.listen('videoSliderOn', StickyFirstItem.hideStickyContainerWhenVideoSliderLoads.trcBind(stickyContainer));
    }

    static hideStickyContainerWhenVideoSliderLoads() {
        if (!StickyFirstItem.isVideoSliderOnFlag) {
            StickyFirstItem.isVideoSliderOnFlag = true;
            const stickyContainerLocalScope = this;
            if (stickyContainerLocalScope
                && stickyContainerLocalScope.id
                && stickyContainerLocalScope.id === StickyFirstItem.CSS_CLASSES.OUTER_CONTAINER) {
                stickyContainerLocalScope.style.display = 'none';
            }
            StickyFirstItem.listenToVideoSlider.remove();
        }
    }
}

(function () {
    const stickyFirstItem = {
        hooks: {
            'item-renderer': function (box, data) {
                if (box.rbox.isFeedCard !== true) return;
                if (!TRC.stickyFirstItemFound) {
                    TRC.stickyFirstItemFound = true;
                    const {manager} = TRC.customHooks[STICKY_FIRST_ITEM_HOOK_NAME];
                    const cmm = TRC.CustomModulesManager;
                    const options = (cmm && cmm.registeredModules && cmm.registeredModules[STICKY_FIRST_ITEM_HOOK_NAME].options) || {};
                    new StickyFirstItem(data, box, manager, options);
                }
            },
            'mode-pub-start': function (mode) {
                if (TRC.customHooks[STICKY_FIRST_ITEM_HOOK_NAME].initialized) return;
                TRC.customHooks[STICKY_FIRST_ITEM_HOOK_NAME].manager = mode.trc;
                TRC.customHooks[STICKY_FIRST_ITEM_HOOK_NAME].initialized = true;
            }
        }
    };

    StickyFirstItem.CSS_CLASSES = {
        DESKTOP: {
            STICKY_ITEM_CONTAINER: 'tbl-desktop-sticky-item',
            STICKY_ITEM_ACTIVE: 'tbl-active-desktop-sticky-item',
            THUMBNAIL_BASE: 'tbl-desktop-sticky-item-thumbnail-base',
            THUMBNAIL: 'tbl-desktop-sticky-item-thumbnail',
            TEXT: 'tbl-desktop-sticky-item-text',
            TRUNCATED_TEXT: 'tbl-desktop-sticky-item-truncated-text',
            TITLE: 'tbl-desktop-sticky-item-title',
            TITLE_EMPTY_DESCRIPTION: 'tbl-desktop-sticky-item-title-empty-description',
            DESCRIPTION: 'tbl-desktop-sticky-item-description',
            BRANDING_WRAPPER: 'tbl-desktop-sticky-item-branding-wrapper',
            BRANDING: 'tbl-desktop-sticky-item-element-branding',
            DISCLOSURE: 'tbl-desktop-sticky-item-element-disclosure'
        },

        MOBILE: {
            STICKY_ITEM_CONTAINER: 'tbl-mobile-sticky-item',
            STICKY_ITEM_ACTIVE: 'tbl-active-mobile-sticky-item',
            THUMBNAIL_BASE: 'tbl-mobile-sticky-item-thumbnail-base',
            THUMBNAIL: 'tbl-mobile-sticky-item-thumbnail',
            TEXT: 'tbl-mobile-sticky-item-text',
            TRUNCATED_TEXT: '',
            TITLE: 'tbl-mobile-sticky-item-title',
            DESCRIPTION: 'tbl-mobile-sticky-item-description',
            BRANDING_WRAPPER: 'tbl-mobile-sticky-item-branding-wrapper',
            BRANDING: 'tbl-mobile-sticky-item-element-branding',
            DISCLOSURE: 'tbl-mobile-sticky-item-element-disclosure'
        },

        OUTER_CONTAINER: 'tbl-sticky-first-item',
        SHOW: 'tbl-sticky-item-show-item',
        DISABLED_CLICKS: 'tbl-sticky-item-disabled-clicks',
        CLOSE_BTN: 'tbl-sticky-item-closeBtn',
        CLOSE_BTN_WRAPPER: 'tbl-sticky-item-closeBtn-wrapper',
        ARROW_BTN: 'tbl-sticky-item-arrowBtn',
        ARROW_BTN_WRAPPER: 'tbl-sticky-item-arrowBtn-wrapper'
    };

    StickyFirstItem.EVENTS = {
        VISIBLE: 'visible',
        HIDDEN: 'hidden',
        CLICK: 'click',
        CLOSED: 'closed'
    };

    StickyFirstItem.isVideoSliderOnFlag = false;

    TRC.customHooks[STICKY_FIRST_ITEM_HOOK_NAME] = stickyFirstItem;
}());